const menuBtn = document.querySelector('.header__btn');
const menu = document.querySelector('.header__menu');
const menuLinks = document.querySelectorAll('.header__el a');

menuBtn.addEventListener('click', menuOpen);
    
function menuOpen(){
    menu.classList.toggle('header__menu--open');
    menuBtn.classList.toggle('header__btn--open');

    if(menu.classList.contains('header__menu--open')){
        document.body.style.overflow = 'hidden';
    } else{
        document.body.style.overflow = 'auto';
    } 
}

function closeMenu() {
    menu.classList.remove('header__menu--open');
    menuBtn.classList.remove('header__btn--open');
    document.body.style.overflow = 'auto';
}

menuLinks.forEach(link => {
    link.addEventListener('click', closeMenu);
});
